import {
  IAgencyData,
  IAgentUser,
  IRegistrationData,
} from "../../@types/api-data.types";
import { LocalStorageEnums } from "../../enums/env.variables.enums";
import { LocalStorageKeys } from "./common.utils";

export class LocalStorageHelpers {
  static getAccessToken = () => {
    let rawToken = "";

    if (typeof window !== "undefined") {
      rawToken = localStorage?.getItem(
        LocalStorageKeys?.brand_temporary_access_token ||
          LocalStorageKeys?.brand_access_token
      ) as string;
    }

    if (rawToken)
      try {
        return rawToken;
      } catch (e) {
        console.error(e);
      }

    return "";
  };

  static setAuthTokens = ({
    access_token,
    refresh_token,
    temporary_access_token,
  }: {
    access_token?: string;
    refresh_token?: string;
    temporary_access_token?: string;
  }) => {
    try {
      if (access_token)
        localStorage.setItem(
          LocalStorageEnums.access_token,
          access_token?.trim()
        );

      if (refresh_token)
        localStorage.setItem(
          LocalStorageEnums.refresh_token,
          refresh_token?.trim()
        );

      if (temporary_access_token)
        localStorage.setItem(
          LocalStorageKeys.brand_temporary_access_token,
          temporary_access_token?.trim()
        );
    } catch (er) {
      console.error("Something went wrong while loading access token");
      console.error(er);
      return {};
    }
  };

  static getAuthTokens = () => {
    let accessToken = "";
    let refreshToken = "";
    let temporaryToken = "";

    try {
      accessToken = localStorage.getItem(LocalStorageEnums.access_token) ?? "";
      refreshToken =
        localStorage.getItem(LocalStorageEnums.refresh_token) ?? "";
      temporaryToken =
        localStorage.getItem(LocalStorageKeys.brand_temporary_access_token) ??
        "";

      return {
        access_token: accessToken,
        refresh_token: refreshToken,
        temporary_access_token: temporaryToken,
      };
    } catch (er) {
      console.error(
        "Something went wrong while retrieving data to local storage"
      );
      console.error(er);
      return {
        access_token: accessToken,
        refresh_token: refreshToken,
        temporary_access_token: temporaryToken,
      };
    }
  };

  static setAgentData = (params: { data: any }) => {
    try {
      localStorage.setItem(
        LocalStorageKeys.agent_data,
        JSON.stringify(params.data)
      );
    } catch (er) {
      console.error("Something went wrong while storing data to local storage");
      console.error(er);
    }
  };

  static getAgentData = (): IAgentUser | null => {
    try {
      return JSON.parse(
        localStorage.getItem(LocalStorageKeys.agent_data) ?? ""
      );
    } catch (er) {
      console.error(
        "Something went wrong while retrieving data to local storage"
      );
      console.error(er);
      return null;
    }
  };

  static setSessionUserType = (params: { type: string }) => {
    try {
      if (!params.type) return;

      localStorage.setItem(LocalStorageKeys.session_user_type, params.type);
    } catch (er) {
      console.error("Something went wrong while storing data to local storage");
      console.error(er);
    }
  };

  static getSessionUserType = (): string | null => {
    try {
      return localStorage.getItem(LocalStorageKeys.session_user_type) ?? "";
    } catch (er) {
      console.error(
        "Something went wrong while retrieving data to local storage"
      );
      console.error(er);
      return null;
    }
  };

  static setAgencyData = (params: { data: any }) => {
    try {
      localStorage.setItem(
        LocalStorageKeys.agency_data,
        JSON.stringify(params.data)
      );
    } catch (er) {
      console.error("Something went wrong while storing data to local storage");
      console.error(er);
    }
  };

  static getAgencyData = (): IAgencyData | null => {
    try {
      return JSON.parse(
        localStorage.getItem(LocalStorageKeys.agency_data) ?? ""
      );
    } catch (er) {
      console.error(
        "Something went wrong while retrieving data to local storage"
      );
      console.error(er);
      return null;
    }
  };

  static setRegistrationData = (params: { data: any }) => {
    try {
      localStorage.setItem(
        LocalStorageKeys.registration_data,
        JSON.stringify(params.data)
      );
    } catch (er) {
      console.error("Something went wrong while storing data to local storage");
      console.error(er);
    }
  };

  static getRegistrationData = (): IRegistrationData | null => {
    try {
      return JSON.parse(
        localStorage.getItem(LocalStorageKeys.registration_data) ?? ""
      );
    } catch (er) {
      console.error("Something went wrong while storing data to local storage");
      console.error(er);
      return null;
    }
  };

  static getUserData = (): IAgentUser | IAgencyData | null => {
  const userType = this.getSessionUserType();
  if (userType === "agent") return this.getAgentData();
  if (userType === "agency") return this.getAgencyData();
  return null;
};

static setItem = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (er) {
    console.error("Error saving to localStorage:", er);
  }
};

static getItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (er) {
    console.error("Error retrieving from localStorage:", er);
    return null;
  }
};


  static clear = () => {
    localStorage.clear();
  };
}
